var map = {
	"./Canvas.vue": "./galaxy/modules/Canvas/resources/js/editor/admin/Canvas.vue",
	"./DocumentIframe.js": "./galaxy/modules/Canvas/resources/js/editor/admin/DocumentIframe.js",
	"./Gallery.vue": "./galaxy/modules/Canvas/resources/js/editor/admin/Gallery.vue",
	"./ModeAndViewportToolbar.vue": "./galaxy/modules/Canvas/resources/js/editor/admin/ModeAndViewportToolbar.vue",
	"./ToolbarTop.vue": "./galaxy/modules/Canvas/resources/js/editor/admin/ToolbarTop.vue",
	"./VersionActions.vue": "./galaxy/modules/Canvas/resources/js/editor/admin/VersionActions.vue",
	"./tooltip.js": "./galaxy/modules/Canvas/resources/js/editor/admin/tooltip.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./galaxy/modules/Canvas/resources/js/editor/admin sync recursive \\.(js%7Cvue)$";